export default {"src":"/_next/static/media/profileDefaultBlue.117237bf.svg","height":80,"width":80};